<template>
  <div class="home">
    <section id="header-home" class="d-flex">
      <div class="container">
        <div class="row">
            <div class="col mb-3">
                <h2>Conheça os detalhes dos planos.</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10">
                <h3>Com o Plano Seguro Internação Dr Achei + Dr.Achei Card você paga apenas R$49,90 e tem direito:</h3>
            </div>
            <div class="col-md-2">
              <router-link tag="a" class="btn btn-primary btn-block" :to="{name: 'FormSinSaude'}">Adquirir</router-link >
            </div>
        </div>
        <br>
        <div class="row">
          <div class="col">
            <h3>Além do Plano Bronze</h3>
          </div>
        </div>
        <plano-gold></plano-gold>
        <br>
        <div class="row">
          <div class="col">
            <h3>+ Seguro Internação</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>Seguro para o TITULAR DO CARTÃO com cobertura de
diária de INTERNAÇÃO hospitalar por doença ou Acidente(DIHAD).Com esse seguro
você receberá uma indenização de até 3 (três diárias) de R$1.000,00(um mil reais)
referente ao período que ficou internado.</p>
<p> Beneficiário: O beneficiário será o próprio
assegurado. <br>
Franquia 12 horas: O seguro poderá ser acionado Após 12 horas de internação e
mínimo de 60 dias de carência.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="card">    
              <div class="card-body">
                <ul>
                  <li>Como Funciona:
                    <p>Você recebe uma indenização de R$1000,00(um mil reais) por dia limitados a 3 diárias. <br>
                    <b>Atenção: Seguro limitado para pessoas com até 65 anos de idade.</b> <br>
                    *É necessário enviar os documentos que comprovem a internação para a Seguradora
                    Mapfre.</p>
                    <p>
                    Atualização monetária de capitais e prêmios: A cada período de 24(vinte e quatro
                    meses), contados da data de início de vigência o capital segurado e o prêmio do seguro
                    serão atualizados.</p>

                  </li>
                </ul>
              </div>
            </div>
            <small>Representante: Sin Assessoria
Empresarial LTDA CNPJ 21.600.797/0001-38.Corretora: Prudenza Assessoria e
Corretagem de Seguros Ltda. SUSEP 100677477 CNPJ: 11.900.386/0001-04
Seguro garantido pela Mapfre Seguros Gerais S.A CNPJ 61.074.175/0001-38 Código
Susep 06238
<a href="../../src/termos_de_contrato_adesao_DR_V2.pdf" target="_blank">Clique aqui </a> e visualize Condições contratuais do Seguro e aceite dos termos e
condições.</small>
          </div>
        </div>
        
      </div>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-md-4 offset-md-4 text-center">
          <p>Gostou? Compre agora!</p>
          <router-link tag="a" class="btn btn-primary btn-lg btn-block" :to="{name: 'FormSinSaude'}">Adquirir</router-link >
        </div>
      </div>
      <br>
      <achei-descontos-mapfre></achei-descontos-mapfre>
    </div>
  </div>
</template>

<script>
import AcheiDescontosMapfre from '@/components/shared/AcheiDescontosMapfre'
import PlanoGold from '@/components/shared/PlanoGold'
export default {
  components: {
    AcheiDescontosMapfre,
    PlanoGold
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/SaibaMaisPlano2.vue